/**
 * Texto do "Resumo da seleção" (visão Justificativas, 2026-10-20) — as
 * frases que o painel monta a partir do que o servidor contou. Puro e
 * testado; o painel só renderiza.
 */

import { approachLabel } from "@/shared/types/mention";
import { polarityLabel } from "@/shared/types/polarity";
import type { SelectionBreakdown } from "@/shared/api/api-client";

const pt = new Intl.NumberFormat("pt-BR");

export function formatCount(value: number): string {
  return pt.format(value);
}

/** "37% das menções" — arredonda pra inteiro, mas nunca mostra 0% pra
 *  quem tem ao menos uma menção ("<1%"). Total zero não tem percentual. */
export function shareOfSelection(count: number, total: number): string | null {
  if (total <= 0) return null;
  const share = (count / total) * 100;
  if (count > 0 && share < 1) return "<1%";
  return `${Math.round(share)}%`;
}

/** "1.234 · 37%" — o valor de uma barra, com a fatia das menções da
 *  seleção (não da soma dos itens: uma menção tem vários temas). */
export function barValue(count: number, total: number): string {
  const share = shareOfSelection(count, total);
  return share ? `${formatCount(count)} · ${share}` : formatCount(count);
}

export type CountChip = { key: string; label: string; count: number };

export function polarityChips(breakdown: SelectionBreakdown): CountChip[] {
  return breakdown.polarities.map(row => ({
    key: `polarity-${row.name ?? "none"}`,
    label: polarityLabel(row.name),
    count: row.count
  }));
}

export function approachChips(breakdown: SelectionBreakdown): CountChip[] {
  return breakdown.approaches.map(row => ({
    key: `approach-${row.value ?? "none"}`,
    label: approachLabel(row.value),
    count: row.count
  }));
}

/** "12 por termo cadastrado · 3 pela IA · 5 por regra de cadastro ·
 *  1 importado · 2 sem registro" — só as origens que aparecem. Conta
 *  LIGAÇÕES menção × tema, e a frase diz isso. Vazio quando não há tema. */
export function describeThemeSources(sources: SelectionBreakdown["theme_sources"]): string {
  const parts: string[] = [];
  if (sources.term) parts.push(`${formatCount(sources.term)} por termo cadastrado`);
  if (sources.ai) parts.push(`${formatCount(sources.ai)} pela IA`);
  if (sources.rule) parts.push(`${formatCount(sources.rule)} por regra de cadastro`);
  if (sources.imported) {
    parts.push(`${formatCount(sources.imported)} ${sources.imported === 1 ? "importado" : "importados"} da planilha`);
  }
  if (sources.none) parts.push(`${formatCount(sources.none)} sem registro de origem`);
  return parts.join(" · ");
}
